import _objectSpread from '@babel/runtime/helpers/objectSpread';
import invariant from 'invariant';
import mitt from 'mitt';
var intialAdapterState = {
  isReady: false,
  flags: {},
  user: {},
  // Typings are incorrect and state that mitt is not callable.
  // Value of type 'MittStatic' is not callable. Did you mean to include 'new'
  // @ts-ignore
  emitter: mitt()
};

var adapterState = _objectSpread({}, intialAdapterState);

var configure = function configure(_ref) {
  var user = _ref.user,
      onFlagsStateChange = _ref.onFlagsStateChange,
      onStatusStateChange = _ref.onStatusStateChange;
  adapterState.user = user;
  return Promise.resolve().then(function () {
    adapterState.isConfigured = true;
    adapterState.isReady = true;
    adapterState.flags = {};
    updateUser(user);
    adapterState.emitter.on('flagsStateChange', onFlagsStateChange);
    adapterState.emitter.on('statusStateChange', onStatusStateChange);
    adapterState.emitter.emit('flagsStateChange', adapterState.flags);
    adapterState.emitter.emit('statusStateChange', {
      isReady: adapterState.isReady,
      isConfigured: adapterState.isConfigured
    });
    adapterState.emitter.emit('readyStateChange');
  });
};

var reconfigure = function reconfigure(_ref2) {
  var user = _ref2.user;
  updateUser(user);
  adapterState.flags = {};
  adapterState.emitter.emit('flagsStateChange', adapterState.flags);
  adapterState.emitter.emit('statusStateChange', {
    isConfigured: adapterState.isConfigured
  });
  return Promise.resolve();
};

var getIsReady = function getIsReady() {
  return Boolean(adapterState.isReady);
};

var setIsReady = function setIsReady(nextIsReady) {
  adapterState.isReady = nextIsReady.isReady;
  adapterState.emitter.emit('statusStateChange', {
    isReady: adapterState.isReady
  });
};

var reset = function reset() {
  adapterState = _objectSpread({}, intialAdapterState);
};

var updateUser = function updateUser(user) {
  adapterState.user = user;
};

var updateFlags = function updateFlags(flags) {
  var isAdapterReady = Boolean(adapterState.isConfigured && adapterState.isReady);
  invariant(isAdapterReady, '@flopflip/memory-adapter: adapter not ready and configured. Flags can not be updated before.');
  if (!isAdapterReady) return;
  adapterState.flags = _objectSpread({}, adapterState.flags, flags);
  adapterState.emitter.emit('flagsStateChange', adapterState.flags);
};

var waitUntilConfigured = function waitUntilConfigured() {
  return new Promise(function (resolve) {
    if (adapterState.isConfigured) resolve();else adapterState.emitter.on('readyStateChange', resolve);
  });
};

var getFlag = function getFlag(flagName) {
  return adapterState.flags && adapterState.flags[flagName];
};

var adapter = {
  getIsReady: getIsReady,
  setIsReady: setIsReady,
  waitUntilConfigured: waitUntilConfigured,
  getFlag: getFlag,
  reset: reset,
  configure: configure,
  reconfigure: reconfigure
};
var version = '1.3.0';
export default adapter;
export { updateFlags, version };